
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gwq0h_10kxa_13",
  "expand-button": "awsui_expand-button_gwq0h_10kxa_48",
  "icon": "awsui_icon_gwq0h_10kxa_52",
  "expanded": "awsui_expanded_gwq0h_10kxa_67",
  "icon-position": "awsui_icon-position_gwq0h_10kxa_77",
  "icon-container": "awsui_icon-container_gwq0h_10kxa_84",
  "icon-container-container": "awsui_icon-container-container_gwq0h_10kxa_88",
  "wrapper": "awsui_wrapper_gwq0h_10kxa_101",
  "wrapper-default": "awsui_wrapper-default_gwq0h_10kxa_109",
  "wrapper-inline": "awsui_wrapper-inline_gwq0h_10kxa_109",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_10kxa_109",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_10kxa_113",
  "wrapper-container": "awsui_wrapper-container_gwq0h_10kxa_116",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_10kxa_120",
  "header-deprecated": "awsui_header-deprecated_gwq0h_10kxa_133",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_10kxa_152",
  "wrapper-not-expanded-without-actions": "awsui_wrapper-not-expanded-without-actions_gwq0h_10kxa_197",
  "header": "awsui_header_gwq0h_10kxa_133",
  "header-wrapper": "awsui_header-wrapper_gwq0h_10kxa_217",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_10kxa_229",
  "header-main": "awsui_header-main_gwq0h_10kxa_237",
  "header-secondary-content": "awsui_header-secondary-content_gwq0h_10kxa_250",
  "header-button": "awsui_header-button_gwq0h_10kxa_258",
  "header-container-button": "awsui_header-container-button_gwq0h_10kxa_258",
  "header-button-icon-end": "awsui_header-button-icon-end_gwq0h_10kxa_287",
  "header-container": "awsui_header-container_gwq0h_10kxa_258",
  "header-navigation": "awsui_header-navigation_gwq0h_10kxa_296",
  "icon-container-end": "awsui_icon-container-end_gwq0h_10kxa_309",
  "header-text": "awsui_header-text_gwq0h_10kxa_349",
  "header-text-hidden": "awsui_header-text-hidden_gwq0h_10kxa_352",
  "content": "awsui_content_gwq0h_10kxa_368",
  "content-expanded": "awsui_content-expanded_gwq0h_10kxa_371",
  "content-compact": "awsui_content-compact_gwq0h_10kxa_374",
  "content-inner": "awsui_content-inner_gwq0h_10kxa_407",
  "content-inner-expanded": "awsui_content-inner-expanded_gwq0h_10kxa_429",
  "content-inner-settled": "awsui_content-inner-settled_gwq0h_10kxa_448",
  "content-inner-body-default": "awsui_content-inner-body-default_gwq0h_10kxa_456",
  "content-inner-body-inline": "awsui_content-inner-body-inline_gwq0h_10kxa_456",
  "content-inner-body-footer": "awsui_content-inner-body-footer_gwq0h_10kxa_459",
  "content-inner-body-container": "awsui_content-inner-body-container_gwq0h_10kxa_462",
  "disable-header-paddings": "awsui_disable-header-paddings_gwq0h_10kxa_467",
  "disable-content-paddings": "awsui_disable-content-paddings_gwq0h_10kxa_472",
  "focusable": "awsui_focusable_gwq0h_10kxa_477",
  "click-target": "awsui_click-target_gwq0h_10kxa_492",
  "header-icon-end": "awsui_header-icon-end_gwq0h_10kxa_499",
  "header-icon-end-with-info": "awsui_header-icon-end-with-info_gwq0h_10kxa_507",
  "header-content": "awsui_header-content_gwq0h_10kxa_584",
  "header-content-with-info": "awsui_header-content-with-info_gwq0h_10kxa_588",
  "header-navigation-content": "awsui_header-navigation-content_gwq0h_10kxa_594"
};
  